import React, { useState, useEffect, useCallback, useContext, useRef } from 'react';
import { MdSave, MdContentCopy, MdArrowBackIosNew } from 'react-icons/md';
import { useParams, useHistory } from "react-router-dom";
import { NotificationManager } from "react-notifications";
import { RenderLayout } from "../../../Plugin/component"
import { TwinSpin } from "react-cssfx-loading";
import { useStyles } from './styles';
import Cookies from 'universal-cookie';
import Button from '@material-ui/core/Button';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import './styles.scss';
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import { SocketContext } from "../../../../Services/socket";
import { useDebounce } from '../../../../hooks';
import Backdrop from '@mui/material/Backdrop';
import moment from 'moment/moment';

const cookies = new Cookies();
function TabPanel(props) {
    const { value, data, onChange } = props;
    return <div className="tab-panel-body">
        <RenderLayout data={data[value].planTypeConfiguration} onChange={onChange} />
    </div>
}

export default function NewComponent(props) {
    let user_name = cookies.get('usercode').email;
    const { id, planID } = useParams();
    const classes = useStyles();
    const [DataPlanTypeConfiguration, SetDataPlanTypeConfiguration] = useState(JSON.parse(localStorage.getItem(`DataPlanTypeDraft${id}`)));
    const [DataPlanTypeConfigurationMain, SetDataPlanTypeConfigurationMain] = useState(JSON.parse(localStorage.getItem(`DataPlanTypeMainDraft${id}`)));
    const [ShowDraft, setShowDraft] = useState(localStorage.getItem(`DataPlanTypeDraft${id}`) || localStorage.getItem(`DataPlanTypeMainDraft${id}`) ? true : false)
    const [TenDuAn, SetTenDuAn] = useState();
    const [value, setValue] = React.useState(0);
    const history = useHistory();
    const refDataNew = React.useRef();
    const [sticky, setSticky] = useState(false)
    let DataPlanTypeConfigurationaray1 = [];
    const socket = useContext(SocketContext);
    const refHeader = useRef()
    const [isLoading, setIsLoading] = useState(false)
    const [currentEmailAzure, setCurrentEmailAzure] = useState([])
    const [currentKeyword, setCurrentKeyword] = useState("");
    const [currentValue, setCurrentValue] = useState([]);
    const [openBackdrop, setOpenBackdrop] = React.useState(false);
    const [checkClone, setCheckClone] = useState();
    const debounce = useDebounce(currentKeyword, 300)

    
    useEffect(() => {
        if(props.DataValidate === undefined || props.DataNew === undefined || props.DataPlan === undefined ||  props.DataLinkApibyid === undefined || props.DataLinkApi === undefined){
            return setOpenBackdrop(true);
        }
        return setOpenBackdrop(false);
    }, [props.DataValidate, props.DataNew, props.DataPlan, props.DataLinkApibyid, props.DataLinkApi])

    useEffect(() => {
        const header = refHeader["current"];
        window.onscroll = () => { handleStickyButton(header) }
        // eslint-disable-next-line
    }, [DataPlanTypeConfiguration, DataPlanTypeConfigurationMain])
    
    useEffect(() => {
        if(window.location.pathname.includes('Edit')){
            setShowDraft(false);
        }
    }, []);

    const handleStickyButton = useCallback((header) => {
        if (header && window.pageYOffset > header.offsetTop) {
            setSticky(true)
        } else {
            setSticky(false)
        }
        // eslint-disable-next-line
    }, [DataPlanTypeConfiguration, DataPlanTypeConfigurationMain])

    //Set array data while Data Plan Handle have type Azure Email
    useEffect(() => {
        if (DataPlanTypeConfiguration && DataPlanTypeConfiguration.length > 0) {
            let array = []
            // eslint-disable-next-line
            DataPlanTypeConfiguration.map((dataPlan, index) => {
                if (dataPlan.type === "Azure Email" && (dataPlan.content !== "" || dataPlan.content)) {
                    array.push({ id: index, name: dataPlan.name, data: dataPlan.content?.split("*") })
                } else if (dataPlan.type === "Azure Email" && (dataPlan.content === "" || dataPlan.content === null)) {
                    array.push({ id: index, name: dataPlan.name, data: [] })
                }
            })
            setCurrentEmailAzure(array)
        }
    }, [DataPlanTypeConfiguration])


    useEffect(() => {
        props.GetDataEmailAzureByName && props.GetDataEmailAzureByName(debounce)
        // eslint-disable-next-line
    }, [debounce]);

    useEffect(() => {
        if (props.DataEmailAzure && props.DataEmailAzure?.Data && props.DataEmailAzure?.Data.length > 0) {
            const array = []
            props.DataEmailAzure.Data.map((value) => {
                return array.push({label: value["EMAIL_ADDR"], value: value["EMAIL_ADDR"]})
            })
            setCurrentValue(array)
        }
    }, [props.DataEmailAzure])

    const storageEmail = localStorage.getItem('Email');

    const HandleCovertDateTime = useCallback((dateTime) => {
        const m = new Date(dateTime);
        const mon = m.getMonth() + 1;
        const dateString =
            m.getFullYear() + "/" + mon + "/" + (m.getDate())
        return dateString.split(" ")[0];
    }, []);

    const HandleCovertEventToDateTime = useCallback((event, type) => {
        if (type === "Datetime") {

            const m = new Date(event);
            const mon = m.getMonth() + 1;
            const dateString =
                m.getFullYear() + "/" + mon + "/" + (m.getDate())
            return `${dateString.split(" ")[0]} ${new Date(event).toLocaleTimeString('en-GB', { hour: 'numeric', minute: 'numeric' })}`;
        } else {
            return event
        }
        // eslint-disable-next-line
    }, [DataPlanTypeConfiguration]);

    
    useEffect(() => {
        const path = window.location.pathname;
        props.GetDataNew(id, planID, path.includes('Edit') ? 2 : 1);
        props.GetDataPlanByPass();
        const DataValidate = {
            ID: id,
            Type: path.includes('Edit') ? 2 : 1,
            PlanID: planID
        }
        props.GetValidateDate(DataValidate);
        const DataLinkApi = {
            "user_name": user_name.includes("@fpt.com.vn") ? user_name.replace("@fpt.com.vn", "") : user_name.replace("@fpt.com", ""),
            "URL": "http://ip.fpt.vn/api/projects"
        }
        props.GetDataLinkApi(DataLinkApi)
        const DataLinkApibyid = {
            "identifier": "integration-gateway",
            "URL": "http://ip.fpt.vn/api/user_project"
        }
        props.GetDataLinkApibyid(DataLinkApibyid)
        return () => {
            props.ClearDataNew();
        }
        // eslint-disable-next-line
    }, []
    )

    useEffect(() => {
        if (props.isResult) {
            history.push({ pathname: `/PlanHandle/Main/${id}` })
        }
        // eslint-disable-next-line
    }, [props.isResult]
    )
    
    useEffect(() => {
        // eslint-disable-next-line
        if (refDataNew.current !== props.DataNew && !DataPlanTypeConfiguration || !DataPlanTypeConfigurationMain) {
            refDataNew.current = props.DataNew;
            const dataNewPlanTypeConfiguration = props.DataNew && props.DataNew.PlanTypeConfiguration
            const checkProjectName = dataNewPlanTypeConfiguration && props.DataNew.PlanTypeConfiguration.filter((item) => item.typeParam === 'Ouput' && item.name.toLowerCase() === 'project name' && item.planTypeConfigurationRefID > 0);
           
            
            if(checkProjectName && checkProjectName.length > 0 && props.DataLinkApi) {
                
                let project_name = props.DataLinkApi.data && props.DataLinkApi.data.filter((item) => item.identifier === checkProjectName[0].content);
                
                if(project_name && project_name.length >0)
                {
                    
                    SetTenDuAn(project_name[0]);
                }
            }
            if (dataNewPlanTypeConfiguration && props.DataNew && props.DataNew.length > 0) {
                // eslint-disable-next-line
                dataNewPlanTypeConfiguration.map((data) => {
                    data.isError = false
                })
            }
            if (dataNewPlanTypeConfiguration) {
                let DataPlanTypeConfigurationaray = [
                    ...dataNewPlanTypeConfiguration.filter(item => { return item.typeParam !== "Ouput" })
                ];
                let DataPlanTypeConfigurationarayfilter = [
                    ...dataNewPlanTypeConfiguration.filter(item => { return item.typeParam !== "Input" && item.type !== "Link liên kết" && item.planTypeConfigurationRefID !== 0 })
                ];
                /*========= Map IsRequired in Input NOT corressponding with reference link ========*/
                let DataPlanTypeConfigurationarayReferenceType = [
                    ...dataNewPlanTypeConfiguration.filter(item => { return item.type === "Link liên kết" })
                ];
                let NewDataPlanTypeConfigurationarayfilter = DataPlanTypeConfigurationarayfilter.map((value) => {
                    DataPlanTypeConfigurationarayReferenceType.map((valueItem) => {
                        if (value.name === valueItem.name) {
                            return value = {
                                ...value, isRequired: valueItem.isRequired
                            }
                        } else {
                            return value
                        }
                    })
                    return value
                })
                /*=============================== Fixed ==================================*/
                
                if (props.DataLinkApi) {

                    DataPlanTypeConfigurationaray.map((item) => {
                        NewDataPlanTypeConfigurationarayfilter.map((item1) => {
                            if (item.id === item1.planTypeConfigurationRefID) {
                                if ((item.data !== "" || item.data !== null) && item.type === "mapsapi") {
                                    DataPlanTypeConfigurationaray1.push(
                                        {
                                            id: item1.id,
                                            idContent: item1.idContent,
                                            configTypeID: item1.configTypeID,
                                            content: item.content,
                                            createBy: item1.createBy,
                                            createDate: item1.createDate,
                                            data: props.DataLinkApi.Data,
                                            api: item.data,
                                            defaultData: item1.defaultData,
                                            disabled: item1.disabled,
                                            editFrom: item1.editFrom,
                                            flex: item1.flex,
                                            index: item1.index,
                                            input: item1.input,
                                            isError: item1.isError,
                                            isRequired: item1.isRequired,
                                            kt: item1.kt,
                                            name: item1.name,
                                            output: item1.output,
                                            page: item1.page,
                                            pinColumn: item1.pinColumn,
                                            planTypeConfigurationChildID: item1.planTypeConfigurationChildID,
                                            planTypeConfigurationMainId: item1.planTypeConfigurationMainId,
                                            planTypeConfigurationRefID: item1.planTypeConfigurationRefID,
                                            planTypeConfigurationDefinitionID: item1.planTypeConfigurationDefinitionID,
                                            planTypeID: item1.planTypeID,
                                            refName: item1.refName,
                                            referenedFieldData: item1.referenedFieldData,
                                            rename: item1.referenedFieldData,
                                            type: "Combobox1",
                                            typeParam: "mapsapi",
                                            value: item1.value,
                                            valueInput: item1.valueInput,
                                            placeholder: "Chọn"
                                        }
                                    )
                                }
                                else {
                                    if (item1.data.includes("Department")) {
                                        DataPlanTypeConfigurationaray1.push(
                                            {
                                                id: item1.id,
                                                idContent: item1.idContent,
                                                configTypeID: item1.configTypeID,
                                                content: item.content,
                                                createBy: item1.createBy,
                                                createDate: item1.createDate,
                                                data: JSON.stringify(props.DataLinkApibyid && props.DataLinkApibyid.data && props.DataLinkApibyid.data[0].department),
                                                api: item.data,
                                                defaultData: item1.defaultData,
                                                disabled: item1.disabled,
                                                editFrom: item1.editFrom,
                                                flex: item1.flex,
                                                index: item1.index,
                                                input: item1.input,
                                                isError: item1.isError,
                                                isRequired: item1.isRequired,
                                                kt: item1.kt,
                                                name: item1.name,
                                                output: item1.output,
                                                page: item1.page,
                                                pinColumn: item1.pinColumn,
                                                planTypeConfigurationChildID: item1.planTypeConfigurationChildID,
                                                planTypeConfigurationMainId: item1.planTypeConfigurationMainId,
                                                planTypeConfigurationRefID: item1.planTypeConfigurationRefID,
                                                planTypeConfigurationDefinitionID: item1.planTypeConfigurationDefinitionID,
                                                planTypeID: item1.planTypeID,
                                                refName: item1.refName,
                                                referenedFieldData: item1.referenedFieldData,
                                                rename: item1.referenedFieldData,
                                                type: "Combobox2",
                                                typeParam: "mapsapi",
                                                value: item1.value,
                                                valueInput: item1.valueInput,
                                                placeholder: "Chọn phòng ban"
                                            }
                                        )
                                    }
                                    else if (item1.data.includes("PM.email")) {
                                        DataPlanTypeConfigurationaray1.push(
                                            {
                                                id: item1.id,
                                                idContent: item1.idContent,
                                                configTypeID: item1.configTypeID,
                                                content: item.content,
                                                createBy: item1.createBy,
                                                createDate: item1.createDate,
                                                data: JSON.stringify(props.DataLinkApibyid && props.DataLinkApibyid.data && props.DataLinkApibyid.data[0].pm),
                                                api: item.data,
                                                defaultData: item1.defaultData,
                                                disabled: item1.disabled,
                                                editFrom: item1.editFrom,
                                                flex: item1.flex,
                                                index: item1.index,
                                                input: item1.input,
                                                isError: item1.isError,
                                                isRequired: item1.isRequired,
                                                kt: item1.kt,
                                                name: item1.name,
                                                output: item1.output,
                                                page: item1.page,
                                                pinColumn: item1.pinColumn,
                                                planTypeConfigurationChildID: item1.planTypeConfigurationChildID,
                                                planTypeConfigurationMainId: item1.planTypeConfigurationMainId,
                                                planTypeConfigurationRefID: item1.planTypeConfigurationRefID,
                                                planTypeConfigurationDefinitionID: item1.planTypeConfigurationDefinitionID,
                                                planTypeID: item1.planTypeID,
                                                refName: item1.refName,
                                                referenedFieldData: item1.referenedFieldData,
                                                rename: item1.referenedFieldData,
                                                type: "Combobox3",
                                                typeParam: "mapsapi",
                                                value: item1.value,
                                                valueInput: item1.valueInput,
                                                placeholder: "Chọn PM"
                                            }
                                        )
                                    }
                                    else if (item1.data.includes("GitLab")) {
                                        let dataOverview = props.DataLinkApibyid && props.DataLinkApibyid.data[0].overview ? props.DataLinkApibyid.data[0].overview.filter((itemm) => itemm.gitLab !== null && itemm.gitLab !== "") : []
                                        DataPlanTypeConfigurationaray1.push(
                                            {
                                                id: item1.id,
                                                idContent: item1.idContent,
                                                configTypeID: item1.configTypeID,
                                                content: item.content,
                                                createBy: item1.createBy,
                                                createDate: item1.createDate,
                                                data: JSON.stringify(dataOverview),
                                                api: item.data,
                                                defaultData: item1.defaultData,
                                                disabled: item1.disabled,
                                                editFrom: item1.editFrom,
                                                flex: item1.flex,
                                                index: item1.index,
                                                input: item1.input,
                                                isError: item1.isError,
                                                isRequired: item1.isRequired,
                                                kt: item1.kt,
                                                name: item1.name,
                                                output: item1.output,
                                                page: item1.page,
                                                pinColumn: item1.pinColumn,
                                                planTypeConfigurationChildID: item1.planTypeConfigurationChildID,
                                                planTypeConfigurationMainId: item1.planTypeConfigurationMainId,
                                                planTypeConfigurationRefID: item1.planTypeConfigurationRefID,
                                                planTypeConfigurationDefinitionID: item1.planTypeConfigurationDefinitionID,
                                                planTypeID: item1.planTypeID,
                                                refName: item1.refName,
                                                referenedFieldData: item1.referenedFieldData,
                                                rename: item1.referenedFieldData,
                                                type: "Combobox4",
                                                typeParam: "mapsapi",
                                                value: item1.value,
                                                valueInput: item1.valueInput,
                                                placeholder: "Chọn trường gitlab"
                                            }
                                        )
                                    }
                                    else if (item1.data.includes("QA.email")) {
                                        DataPlanTypeConfigurationaray1.push(
                                            {
                                                id: item1.id,
                                                idContent: item1.idContent,
                                                configTypeID: item1.configTypeID,
                                                content: item.content,
                                                createBy: item1.createBy,
                                                createDate: item1.createDate,
                                                data: JSON.stringify(props.DataLinkApibyid && props.DataLinkApibyid.data && props.DataLinkApibyid.data[0].qa),
                                                api: item.data,
                                                defaultData: item1.defaultData,
                                                disabled: item1.disabled,
                                                editFrom: item1.editFrom,
                                                flex: item1.flex,
                                                index: item1.index,
                                                input: item1.input,
                                                isError: item1.isError,
                                                isRequired: item1.isRequired,
                                                kt: item1.kt,
                                                name: item1.name,
                                                output: item1.output,
                                                page: item1.page,
                                                pinColumn: item1.pinColumn,
                                                planTypeConfigurationChildID: item1.planTypeConfigurationChildID,
                                                planTypeConfigurationMainId: item1.planTypeConfigurationMainId,
                                                planTypeConfigurationRefID: item1.planTypeConfigurationRefID,
                                                planTypeConfigurationDefinitionID: item1.planTypeConfigurationDefinitionID,
                                                planTypeID: item1.planTypeID,
                                                refName: item1.refName,
                                                referenedFieldData: item1.referenedFieldData,
                                                rename: item1.referenedFieldData,
                                                type: "Combobox5",
                                                typeParam: "mapsapi",
                                                value: item1.value,
                                                valueInput: item1.valueInput,
                                                placeholder: "Chọn QA"
                                            }
                                        )
                                    }
                                    else {
                                        let projectNames = props.DataLinkApi && props.DataLinkApi.data &&  props.DataLinkApi.data.filter((itemm)=> itemm.project_name !== null && itemm.project_name !== "" && itemm.project_name !== undefined);
                                        DataPlanTypeConfigurationaray1.push(
                                            {
                                                id: item1.id,
                                                idContent: item1.idContent,
                                                configTypeID: item1.configTypeID,
                                                content: item.content,
                                                createBy: item1.createBy,
                                                createDate: item1.createDate,
                                                data: JSON.stringify(projectNames ? projectNames : []),
                                                api: item.data,
                                                defaultData: item1.defaultData,
                                                disabled: item1.disabled,
                                                editFrom: item1.editFrom,
                                                flex: item1.flex,
                                                index: item1.index,
                                                input: item1.input,
                                                isError: item1.isError,
                                                isRequired: item1.isRequired,
                                                kt: item1.kt,
                                                name: item1.name,
                                                output: item1.output,
                                                page: item1.page,
                                                pinColumn: item1.pinColumn,
                                                planTypeConfigurationChildID: item1.planTypeConfigurationChildID,
                                                planTypeConfigurationMainId: item1.planTypeConfigurationMainId,
                                                planTypeConfigurationRefID: item1.planTypeConfigurationRefID,
                                                planTypeConfigurationDefinitionID: item1.planTypeConfigurationDefinitionID,
                                                planTypeID: item1.planTypeID,
                                                refName: item1.refName,
                                                referenedFieldData: item1.referenedFieldData,
                                                rename: item1.referenedFieldData,
                                                type: "Combobox1",
                                                typeParam: "mapsapi",
                                                value: item1.value,
                                                valueInput: item1.valueInput,
                                                placeholder: "Chọn tên dự án"
                                            }
                                        )
                                    }
                                }
                            }
                            return true;
                        })
                        return true;
                    })

                    let array = [...DataPlanTypeConfigurationaray1, ...dataNewPlanTypeConfiguration.filter(item => { return item.type !== "Link liên kết" && item.typeParam !== "Ouput" && item.typeParam !== "Input" })];
                    
                    const arrayCopy = array.map(item => {
                        if (!item.content && item.type === "Datetime") {
                            item.content = `${HandleCovertDateTime(new Date())} ${new Date().toLocaleTimeString('en-GB', { hour: 'numeric', minute: 'numeric' })}`
                            return item
                        }
                        return item
                    })
                    let arraySort = arrayCopy.map((item) =>{
                        return {...item, index: item.planTypeConfigurationRefID !==0 ? item.planTypeConfigurationRefID : item.id}
                    })
                    const numAscending = arraySort.sort((a, b) => {
                        return a.index - b.index;
                    });

                    if (!DataPlanTypeConfiguration) {   
                        if(window.location.pathname.includes('Edit')){
                            let arraySortEdit = props.DataNew.PlanTypeConfiguration.map((item) =>{
                                return {...item, index: item.planTypeConfigurationRefID !==0 ? item.planTypeConfigurationRefID : item.id}
                            })
                            const numAscendingEdit = arraySortEdit.sort((a, b) => {
                                return a.index - b.index;
                            });
                            SetDataPlanTypeConfiguration(numAscending)
                        }else{
                             SetDataPlanTypeConfiguration(numAscending);      
                        }
                        
                    } else {       

                        if(window.location.pathname.includes('Edit')){
                            let arraySortEdit = props.DataNew.PlanTypeConfiguration.map((item) =>{
                                return {...item, index: item.planTypeConfigurationRefID !==0 ? item.planTypeConfigurationRefID : item.id}
                            })
                            const numAscendingEdit = arraySortEdit.sort((a, b) => {
                                return a.index - b.index;
                            });
                            SetDataPlanTypeConfiguration(numAscending)
                        }else{
                             SetDataPlanTypeConfiguration(DataPlanTypeConfiguration)                         
                        }                
                        
                    }
                    const DataPlanTypeConfigDefaultAssignee = props.DataNew && props.DataNew.PlanTypeConfigurationMain.map((item, index) => {
                        if (index === 0 && item.planTypeConfiguration[0].content && item.planTypeConfiguration[0].content !== storageEmail && !item.planTypeConfiguration[0].content.includes(storageEmail)) {
                            if (storageEmail === null) {
                                NotificationManager.error("Lỗi không lấy được nhân viên phụ trách. Vui lòng F5 hoặc đăng nhập lại")
                            }
                            item.planTypeConfiguration[0].content = `${item.planTypeConfiguration[0].content}*${storageEmail}`;
                            return item
                        } else if (index === 0 && !item.planTypeConfiguration[0].content) {
                            if (storageEmail === null) {
                                NotificationManager.error("Lỗi không lấy được nhân viên phụ trách. Vui lòng F5 hoặc đăng nhập lại")
                            }
                            item.planTypeConfiguration[0].content = `${storageEmail}`;
                            return item
                        }
                        return item;
                    })
                    if (!DataPlanTypeConfigurationMain) {
                        if(window.location.pathname.includes('Edit')){
                             SetDataPlanTypeConfigurationMain(props.DataNew.PlanTypeConfigurationMain)
                        }else{
                             SetDataPlanTypeConfigurationMain(DataPlanTypeConfigDefaultAssignee);
                        }
                       
                    } else {
                        if(window.location.pathname.includes('Edit')){
                             SetDataPlanTypeConfigurationMain(props.DataNew.PlanTypeConfigurationMain)
                        }else{
                             SetDataPlanTypeConfigurationMain(DataPlanTypeConfigurationMain);
                        }
                    }
                }  
            }

        } else if (DataPlanTypeConfiguration && DataPlanTypeConfigurationMain) {            
            if(window.location.pathname.includes('Edit') && props.DataNew !== undefined){
                setShowDraft(false);
                const dataNewPlanTypeConfiguration = props.DataNew && props.DataNew.PlanTypeConfiguration
                if(dataNewPlanTypeConfiguration === undefined)
                    return;
                let array = [...DataPlanTypeConfigurationaray1, ...dataNewPlanTypeConfiguration.filter(item => { return item.type !== "Link liên kết" && item.typeParam !== "Ouput" && item.typeParam !== "Input" })];
                    
                const arrayCopy = array.map(item => {
                    if (!item.content && item.type === "Datetime") {
                        item.content = `${HandleCovertDateTime(new Date())} ${new Date().toLocaleTimeString('en-GB', { hour: 'numeric', minute: 'numeric' })}`
                        return item
                    }
                    return item
                })
                let arraySort = arrayCopy.map((item) =>{
                    return {...item, index: item.planTypeConfigurationRefID !==0 ? item.planTypeConfigurationRefID : item.id}
                })
                const numAscending = arraySort.sort((a, b) => {
                    return a.index - b.index;
                });
                SetDataPlanTypeConfiguration(numAscending)
                SetDataPlanTypeConfigurationMain(props.DataNew.PlanTypeConfigurationMain)
            }
            else{
                SetDataPlanTypeConfiguration(DataPlanTypeConfiguration)
                SetDataPlanTypeConfigurationMain(DataPlanTypeConfigurationMain)
            }
        }
        // eslint-disable-next-line
    }, [props.DataNew])

    useEffect(() => {
        if (props.DataFile) {
            SetDataPlanTypeConfiguration([
                ...DataPlanTypeConfiguration.slice(0, props.DataFile.index),
                {
                    ...DataPlanTypeConfiguration[props.DataFile.index],
                    content: props.DataFile.file,
                },
                ...DataPlanTypeConfiguration.slice(props.DataFile.index + 1)
            ]);
            
        }
        // eslint-disable-next-line
    }, [props.DataFile]
    )
    useEffect(() => {
        if (DataPlanTypeConfiguration && DataPlanTypeConfigurationaray1) {
            SetDataPlanTypeConfiguration(...DataPlanTypeConfiguration, ...DataPlanTypeConfigurationaray1);
        }

        
        // eslint-disable-next-line
    }, [DataPlanTypeConfigurationaray1.length > 0])

    
    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    const handleDownload = (value) => {
        props.DownloadFile(value);
    }

    const convertStringToBoolean = (value) => value === "true"

    const handleLoading = () => {
        setIsLoading(true);
    }
    const checkDateDeploy = (dateDeployStart) => {
        const dateDeploy = new Date(dateDeployStart);
        const dateCurrent = new Date();
        var flag = 0;
        var dateArray = [];
        var currentDate = moment(dateCurrent);
        var stopDate = moment(dateDeploy);
        while (currentDate <= stopDate) {
            dateArray.push(moment(currentDate).format('YYYY-MM-DD'))
            currentDate = moment(currentDate).add(1, 'days');
        }
        const dateSunday = dateArray && dateArray.filter((item) => moment(item).day() === 0);
        const dateSaturday = dateArray && dateArray.filter((item) => moment(item).day() === 6);
        if (dateSunday.length > 0 && dateSaturday.length > 0 && dateCurrent.getDay() !== 0 && dateCurrent.getDay() !== 6) {
            const sunday = moment(dateSunday[0].toString() + ' 23:59:59');
            const saturday = moment(dateSaturday[0].toString() + ' 00:00:00');
            var second1 = saturday.diff(moment(dateCurrent), "seconds");
            var second2 = stopDate.diff(sunday, "seconds");
            var sumseconds = second1 + second2;
            if (sumseconds <= 201601) {
                flag = 1;
            }
            else {
                flag = 0;
            }
        }
        else if (dateCurrent.getDay() === 0 || dateCurrent.getDay() === 6) {
            var day = dateCurrent.getDay();
            var dateSubtract = new Date();
            if (day === 0) {
                var date2 = moment(dateCurrent).add(1, 'day').format("YYYY-MM-DD");
                dateSubtract = new Date(date2.toString() + ' 00:00:00');
            }
            else if (day === 6) {
                var date22 = moment(dateCurrent).add(2, 'day').format("YYYY-MM-DD");
                dateSubtract = new Date(date22.toString() + ' 00:00:00');
            }
            var inputDate = moment(dateDeploy);
            var secondsDeploy = inputDate.diff(dateSubtract, "seconds");
            if (secondsDeploy <= 201600) {
                flag = 1;
            }
            else {
                flag = 0;
            }
        }
        else {
            var currentDate1 = moment(dateCurrent);
            var stopDate1 = moment(dateDeploy);
            var secondsDeploy2 = stopDate1.diff(currentDate1, "seconds");
            if (secondsDeploy2 <= 201600) {
                flag = 1;
            }
            else {
                flag = 0;
            }
        }
        return flag;
    }
    // const checkDateDeployValid = (dateDeploy) => {
    //     var currentDate = new Date('2022-12-29 13:00:00');
    //     var day = currentDate.getDay();
    //     if (day === 0) {
    //         var date2 = moment(currentDate).add(1, 'day').format("YYYY-MM-DD");
    //         currentDate = new Date(date2.toString() + ' 00:00:00');
    //     }
    //     else if (day === 6) {
    //         var date2 = moment(currentDate).add(2, 'day').format("YYYY-MM-DD");
    //         currentDate = new Date(date2.toString() + ' 00:00:00');
    //     }
    //     if (day === 0 || day === 6) {
    //         var inputDate = moment(dateDeploy);
    //         var secondsDeploy = inputDate.diff(currentDate, "seconds");
    //         if (secondsDeploy < 201600) {
    //             return 1;
    //         }
    //         else {
    //             return 0;
    //         }
    //     }
    //     else {

    //     }
    // }
 
    const handleSave = () => {
        localStorage.removeItem(`DataPlanTypeMainDraft${id}`)
        localStorage.removeItem(`DataPlanTypeDraft${id}`)
        
        const DataPlanTypeConfigurationCopy = DataPlanTypeConfiguration.map(dataPlan => {
            const condition = !dataPlan.content && convertStringToBoolean(dataPlan.isRequired) && dataPlan.type !== "Lable" && dataPlan.type !== "Datetime";

            return { ...dataPlan, isError: condition }
        })
        SetDataPlanTypeConfiguration(DataPlanTypeConfigurationCopy);

        let DataPlanTypeConfigurationNotInLable = DataPlanTypeConfiguration.filter((item) => { return !item.content && item.isRequired === "true" && item.type !== "Lable" && item.type !== "Datetime" && item.type !== "File" && item.type !== "Editor" })
        const DataPlanTypeConfigurationNotInLableName = DataPlanTypeConfigurationNotInLable.map(item => {
            return item.name
        })
        if (DataPlanTypeConfigurationNotInLable.length > 0) {
            NotificationManager.error(`Vui lòng nhập thông tin ${DataPlanTypeConfigurationNotInLableName.join(", ")}`)
            return false;
        }
     
        DataPlanTypeConfigurationMain.forEach((item, index) =>  {
            if( item.planTypeConfiguration[0].content === null){
                return;
            }
            var contents = item.planTypeConfiguration[0].content.split("*"); 
            for (var i = 0; i < contents.length; i++) {
                contents[i] = contents[i].replace('.vn', "");
            }
            item.planTypeConfiguration[0].content = contents.join("*"); 
        });

        let isData = true;
        DataPlanTypeConfigurationMain.every((item) => {
            let isDataValue = true;
            item.planTypeConfiguration.every((item) => {
                if (!item.content) {
                    isDataValue = false;
                    return false;
                }
                return true;
            });
            if (!isDataValue) {
                NotificationManager.error(`Vui lòng phân công nhân viên phụ trách ở bước ${item.stepName}.`);
                isData = false;
                return false;
            }
            return true;
        })

        if (!isData) {
            return false;
        }
        let PlanTypeConfigurationValueMain = [
            ...DataPlanTypeConfiguration
        ];
        // eslint-disable-next-line
        DataPlanTypeConfigurationMain.map((item) => {
            // eslint-disable-next-line
            item.planTypeConfiguration.map((item1) => {
                PlanTypeConfigurationValueMain = [
                    ...PlanTypeConfigurationValueMain,
                    {
                        ...item1
                    }
                ]
            })
        })

        const cookies = new Cookies();
        const userCode = cookies.get('usercode').userCode;


        let arr = [...PlanTypeConfigurationValueMain];
        // eslint-disable-next-line
        PlanTypeConfigurationValueMain.map((item, index) => {
            if (item.type === "Combobox5") {
                arr = [
                    ...arr.slice(0, index),
                    {
                        ...arr[index],
                        content: item.content === null || item.content.email === null || item.content === "" || item.content === undefined ? "" : item.content.email,
                        data: item.content === null || item.content.email === null || item.content === "" || item.content === undefined  ? "" : item.content.email,
                    },
                    ...arr.slice(index + 1)
                ]
            }
            if (item.type === "Combobox4") {
                arr = [
                    ...arr.slice(0, index),
                    {
                        ...arr[index],
                        content: item.content === null || item.content.gitLab === null || item.content === "" || item.content === undefined ? "" : item.content.gitLab,
                        data: item.content === null || item.content.gitLab === null || item.content === "" || item.content === undefined ? "" : item.content.gitLab,
                    },
                    ...arr.slice(index + 1)
                ]
            }
            if (item.type === "Combobox3") {
                arr = [
                    ...arr.slice(0, index),
                    {
                        ...arr[index],
                        content: item.content === null || item.content.email === null || item.content === "" || item.content === undefined ? "" : item.content.email,
                        data: item.content === null || item.content.email === null || item.content === "" || item.content === undefined ? "" : item.content.email
                    },
                    ...arr.slice(index + 1)
                ]
            }
            if (item.type === "Combobox2") {
                arr = [
                    ...arr.slice(0, index),
                    {
                        ...arr[index],
                        content: item.content === null || item.content.department_name === null || item.content === "" || item.content === undefined ? "" : item.content.department_name,
                        data: item.content === null || item.content.department_name === null || item.content === "" || item.content === undefined ? "" : item.content.department_name
                    },
                    ...arr.slice(index + 1)
                ]
            }
            if (item.type === "Combobox1") {
                arr = [
                    ...arr.slice(0, index),
                    {
                        ...arr[index],
                        content: item.content.identifier,
                        data: item.content.identifier
                    },
                    ...arr.slice(index + 1)
                ]
            }
        })

        const path = window.location.pathname;
        const projectName = arr && arr.filter((item) => (item.name.toLowerCase() === 'project name' || item.name.toLowerCase() === 'projectname') && item.type !== 'Link liên kết');
        const checkByPass = checkByPassCreatePlan(projectName);
        const timeStart = arr && arr.filter((item) => item.name === "Thời gian dự kiến bắt đầu" && item.type === 'Datetime');
        const timeEnd = arr && arr.filter((item) => item.name === "Thời gian dự kiến kết thúc" && item.type === 'Datetime');
        
        if (path.includes("Edit")) {
            if ((timeStart && timeStart.length > 0) && (timeEnd && timeEnd.length > 0) && (props.DataValidate && props.DataValidate.isValidateDate === true) && checkByPass === 1) {
                let convertDateTimeStart = new Date(timeStart[0].content);
                let convertDateTimeEnd = new Date(timeEnd[0].content);
                let requireDateEnd = moment(convertDateTimeStart).add(1, 'days').format("DD-MM-YYYY")
                // let requireDateStart = moment(convertDateTimeStart).format("YYYY-MM-DD 22:00")
                if (checkDateValidate(convertDateTimeStart, convertDateTimeEnd) === 1) {
                    NotificationManager.warning("Thời gian dự kiến bắt đầu phải từ 22: 00 !");
                }
                else if (checkDateValidate(convertDateTimeStart, convertDateTimeEnd) === 2) {
                    NotificationManager.warning("Thời gian dự kiến kết thúc tối đa 1:00 ngày "+requireDateEnd +" !");
                }
                else if (checkDateValidate(convertDateTimeStart, convertDateTimeEnd) === 3) {
                    NotificationManager.warning("Thời gian dự kiến kết thúc phải lớn hơn thời gian dự kiến bắt đầu");
                }
                else {
                    props.SetDataNew({ PlanTypeConfigurationValue: arr, PlanTypeID: id, Status: "Edit", CreateBy: userCode, Type: 2, PlanID: planID, planTypeConfigurationDefinitionID : DataPlanTypeConfiguration[0].planTypeConfigurationDefinitionID })
                    handleLoading();
                }
            }
            else {
                if ((timeStart && timeStart.length > 0) && (timeEnd && timeEnd.length > 0)) {
                    let convertDateTimeStart = new Date(timeStart[0].content);
                    let convertDateTimeEnd = new Date(timeEnd[0].content);
                    if (checkDateValidate(convertDateTimeStart, convertDateTimeEnd) === 3) {
                        NotificationManager.warning("Thời gian dự kiến kết thúc phải lớn hơn thời gian dự kiến bắt đầu");
                    }
                    else {
                        props.SetDataNew({ PlanTypeConfigurationValue: arr, PlanTypeID: id, Status: "Edit", CreateBy: userCode, Type: 2, PlanID: planID, planTypeConfigurationDefinitionID : DataPlanTypeConfiguration[0].planTypeConfigurationDefinitionID })
                        handleLoading();
                    }
                }
                else {
                    props.SetDataNew({ PlanTypeConfigurationValue: arr, PlanTypeID: id, Status: "Edit", CreateBy: userCode, Type: 2, PlanID: planID, planTypeConfigurationDefinitionID : DataPlanTypeConfiguration[0].planTypeConfigurationDefinitionID })
                    handleLoading();
                }
            }
        }
        else {
            if (timeStart.length > 0 && timeEnd.length > 0 && (props.DataValidate && props.DataValidate.isValidateDate === true) && checkByPass === 1) {
                let convertDateTimeStart = new Date(timeStart[0].content);
                let convertDateTimeEnd = new Date(timeEnd[0].content);
                let requireDateEnd = moment(convertDateTimeStart).add(1, 'days').format("DD-MM-YYYY")
                // let requireDateEnd = moment(convertDateTimeEnd).format("YYYY-MM-DD 01:00")
                // let requireDateStart = moment(convertDateTimeStart).format("YYYY-MM-DD 22:00")
                if (checkDateValidate(convertDateTimeStart, convertDateTimeEnd) === 1) {
                    NotificationManager.warning("Thời gian dự kiến bắt đầu phải từ 22: 00 !");
                }
                else if (checkDateValidate(convertDateTimeStart, convertDateTimeEnd) === 2) {
                    NotificationManager.warning("Thời gian dự kiến kết thúc tối đa 1:00 ngày "+requireDateEnd +" !");
                }
                else 
                if (checkDateValidate(convertDateTimeStart, convertDateTimeEnd) === 3) {
                    NotificationManager.warning("Thời gian dự kiến kết thúc phải lớn hơn thời gian dự kiến bắt đầu");
                }
                else if (checkDateDeploy(timeStart[0].content) === 1) {
                    NotificationManager.warning("Tạo kế hoạch trước 2 ngày nhé!");
                }
                else {
                    props.SetDataNew({ PlanTypeConfigurationValue: arr, PlanTypeID: id, Status: "Save", CreateBy: userCode, Type: 1, planTypeConfigurationDefinitionID : DataPlanTypeConfiguration[0].planTypeConfigurationDefinitionID })
                    handleLoading();
                }
            }
            else {
                if ((timeStart && timeStart.length > 0) && (timeEnd && timeEnd.length > 0)) {
                    let convertDateTimeStart = new Date(timeStart[0].content);
                    let convertDateTimeEnd = new Date(timeEnd[0].content);
                    if (checkDateValidate(convertDateTimeStart, convertDateTimeEnd) === 3) {
                        NotificationManager.warning("Thời gian dự kiến kết thúc phải lớn hơn thời gian dự kiến bắt đầu");
                    }
                    else {
                        props.SetDataNew({ PlanTypeConfigurationValue: arr, PlanTypeID: id, Status: "Save", CreateBy: userCode, Type: 1, planTypeConfigurationDefinitionID : DataPlanTypeConfiguration[0].planTypeConfigurationDefinitionID })
                        handleLoading();
                    }
                }
                else {
                    props.SetDataNew({ PlanTypeConfigurationValue: arr, PlanTypeID: id, Status: "Save", CreateBy: userCode, Type: 1, planTypeConfigurationDefinitionID : DataPlanTypeConfiguration[0].planTypeConfigurationDefinitionID })
                    handleLoading();
                }
            }
        }
        socket.emit("send-message-by-email", { message: "", email: user_name });
    };
    
    const checkByPassCreatePlan = (arrProjectName) =>{
        let flag = 1;
       if((props.DataPlan && props.DataPlan.length === 0)|| arrProjectName.length === 0){
            flag = 1;
       }
       else{
        // eslint-disable-next-line
            arrProjectName.map((item) =>{
                let check = props.DataPlan && props.DataPlan.filter((itemm) => itemm.projectName === item.content);
                if(check.length > 0){
                    flag = 0;
                }
            })
       }
       return flag;
    }
    const checkDateValidate = (dateStart, dateEnd) => {
        let convertDateTimeStart = new Date(dateStart);
        let convertDateTimeEnd = new Date(dateEnd);
        let requireDateEnd = moment(convertDateTimeStart).add(1, 'days').format("YYYY-MM-DD 01:00")
        let requireDateStart = moment(convertDateTimeStart).format("YYYY-MM-DD 22:00")
        if (convertDateTimeEnd <= convertDateTimeStart) {
            return 3;
        }
        else if (convertDateTimeStart < new Date(requireDateStart)) {
            return 1;
        }
        else if (convertDateTimeEnd > new Date(requireDateEnd)) {
            return 2
        }

    }

    const handleSaveDefaultData = () => {
        localStorage.removeItem(`DataPlanTypeMainDraft${id}`)
        localStorage.removeItem(`DataPlanTypeDraft${id}`)
        let PlanTypeConfigurationValueMain = [
            ...DataPlanTypeConfiguration
        ];
        // eslint-disable-next-line
        DataPlanTypeConfigurationMain.map((item) => {
            // eslint-disable-next-line
            item.planTypeConfiguration.map((item1) => {
                PlanTypeConfigurationValueMain = [
                    ...PlanTypeConfigurationValueMain,
                    {
                        ...item1
                    }
                ]
            })
        })

        let arr = [...PlanTypeConfigurationValueMain];
        // eslint-disable-next-line
        PlanTypeConfigurationValueMain.map((item, index) => {
            if (item.type === "Combobox5") {
                arr = [
                    ...arr.slice(0, index),
                    {
                        ...arr[index],
                        content: JSON.stringify(item.content)
                    },
                    ...arr.slice(index + 1)
                ]
            }
            if (item.type === "Combobox4") {
                arr = [
                    ...arr.slice(0, index),
                    {
                        ...arr[index],
                        content: JSON.stringify(item.content)
                    },
                    ...arr.slice(index + 1)
                ]
            }
            if (item.type === "Combobox3") {
                arr = [
                    ...arr.slice(0, index),
                    {
                        ...arr[index],
                        content: JSON.stringify(item.content)
                    },
                    ...arr.slice(index + 1)
                ]
            }
            if (item.type === "Combobox2") {
                arr = [
                    ...arr.slice(0, index),
                    {
                        ...arr[index],
                        content: JSON.stringify(item.content)
                    },
                    ...arr.slice(index + 1)
                ]
            }
            if (item.type === "Combobox1") {
                arr = [
                    ...arr.slice(0, index),
                    {
                        ...arr[index],
                        content: JSON.stringify(item.content)
                    },
                    ...arr.slice(index + 1)
                ]
            }
        })
        //props.SetDataNew({ PlanTypeConfigurationValue: PlanTypeConfigurationValueMain, PlanTypeID: id, Status: "SaveDefaultData" })
        props.SetDataNew({ PlanTypeConfigurationValue: arr, PlanTypeID: id, Status: "SaveDefaultData" })
        socket.emit("send-message-by-email", { message: "", email: user_name });

    };

    const handleCancel = () => {
        history.push({ pathname: `/PlanHandle/Main/${id}` })
    };

    
    
    useEffect(() => {
        if (DataPlanTypeConfiguration && DataPlanTypeConfigurationaray1) {

            if (props.DataLinkApibyid) {
                let array = [...DataPlanTypeConfiguration]
                // eslint-disable-next-line
                DataPlanTypeConfiguration.map((item, index) => {
                    
                    if (item.type === "Combobox3") {                        
                        let pm1 = [{ "user_name": "VietNQ27", "full_name": "Nguyễn Quốc Việt", "email": "VietNQ27@fpt.com" }]
                        let check = props.DataLinkApibyid.data[0].pm;

                        //const checkProjectName = DataPlanTypeConfiguration && DataPlanTypeConfiguration.filter((item) => item.typeParam === 'Ouput' && (item.name.toLowerCase() === 'pm' || item.name.toLowerCase() === 'pm (email)')  && item.planTypeConfigurationRefID > 0);
                        const findPM = props.DataLinkApibyid.data[0].pm.filter((itemm) => {
                            if (item.content && typeof item.content === 'string') {
                                return item.content.replace('@fpt.com.vn', '@fpt.com') === itemm.email
                            }
                            else if (item.content && typeof item.content === 'object') {
                                return item.content.email === itemm.email
                            } else {
                                return item.content === itemm.email
                            }
                        });

                        if (check) {
                            let pms = props.DataLinkApibyid.data && props.DataLinkApibyid.data[0].pm.filter((itemm => itemm.email !== null && itemm.email !== undefined));
                            array = [
                                ...array.slice(0, index),
                                {
                                    ...array[index],
                                    content: findPM && findPM.length > 0 ? findPM[0] : "",
                                    data: JSON.stringify(pms ? pms : [])
                                },
                                ...array.slice(index + 1)
                            ]
                        }
                        else {
                            array = [
                                ...array.slice(0, index),
                                {
                                    ...array[index],
                                    data: JSON.stringify(pm1)
                                },
                                ...array.slice(index + 1)
                            ]
                        }
                    }
                    if (item.type === "Combobox1") {
                        const findprojectName = props.DataLinkApi && props.DataLinkApi.data.filter((itemm) => item.content === itemm.identifier);
                        array = [
                            ...array.slice(0, index),
                            {
                                ...array[index],
                                content: findprojectName && findprojectName.length > 0 ? findprojectName[0] : item.content,
                                data: props.DataLinkApi && JSON.stringify(props.DataLinkApi.data)
                            },
                            ...array.slice(index + 1)
                        ]
                    }
                    if (item.type === "Combobox2") {
                        let departments = props.DataLinkApibyid.data && props.DataLinkApibyid.data[0].department.filter((itemm => itemm.department_name !== null && itemm.department_name !== undefined));
                        const findDepartment = props.DataLinkApibyid.data && props.DataLinkApibyid.data[0].department.filter((itemm) => item.content === itemm.department_name);
                        array = [
                            ...array.slice(0, index),
                            {
                                ...array[index],
                                content: findDepartment && findDepartment.length > 0 ? findDepartment[0] : "",
                                data: JSON.stringify(departments ?  departments : [])
                            },
                            ...array.slice(index + 1)
                        ]
                    }
                    if (item.type === "Combobox4") {
                        let dataOverview = props.DataLinkApibyid.data && props.DataLinkApibyid.data[0].overview ? props.DataLinkApibyid.data[0].overview.filter((itemm) => itemm.gitLab !== null && itemm.gitLab !== undefined) : []
                        const findGitLab = props.DataLinkApibyid.data && props.DataLinkApibyid.data[0].overview.filter((itemm) => item.content === itemm.gitLab);
                        array = [
                            ...array.slice(0, index),
                            {
                                ...array[index],
                                content: findGitLab && findGitLab.length > 0 ? findGitLab[0] : "",
                                data: JSON.stringify(dataOverview ? dataOverview : [])
                            },
                            ...array.slice(index + 1)
                        ]
                    }
                    if (item.type === "Combobox5") {
                        let dataQAemail = props.DataLinkApibyid.data && props.DataLinkApibyid.data[0].qa ? props.DataLinkApibyid.data[0].qa.filter((itemm) => itemm.email !== null && itemm.email !== undefined) : []
                        const findemail = props.DataLinkApibyid.data && props.DataLinkApibyid.data[0].qa.filter((itemm) => item.content === itemm.email);
                        array = [
                            ...array.slice(0, index),
                            {
                                ...array[index],
                                content: findemail && findemail.length > 0 ? findemail[0] : "",
                                data: JSON.stringify(dataQAemail ? dataQAemail : [])
                            },
                            ...array.slice(index + 1)
                        ]
                    }                    
                })
                
                if(checkClone){
                    setCheckClone(false);
                    return;
                }
                SetDataPlanTypeConfiguration([...array]);   
            }
        }
        // eslint-disable-next-line
    }, [props.DataLinkApibyid])

    useEffect(() => {
        if (TenDuAn) {
            const DataLinkApibyid = {
                "identifier": TenDuAn.identifier,
                "URL": "http://ip.fpt.vn/api/user_project"
            }
            props.GetDataLinkApibyid(DataLinkApibyid)
        }
        if (DataPlanTypeConfiguration && DataPlanTypeConfigurationaray1) {

            let array = [...DataPlanTypeConfiguration]
            // eslint-disable-next-line
            DataPlanTypeConfiguration.map((item, index) => {
                if (item.type === "Combobox3") {
                    array = [
                        ...array.slice(0, index),
                        {
                            ...array[index],
                            content: item.content
                        },
                        ...array.slice(index + 1)
                    ]
                }
                if (item.type === "Combobox2") {
                    array = [
                        ...array.slice(0, index),
                        {
                            ...array[index],
                            content: item.content
                        },
                        ...array.slice(index + 1)
                    ]
                }
                if (item.type === "Combobox4") {
                    array = [
                        ...array.slice(0, index),
                        {
                            ...array[index],
                            content: item.content
                        },
                        ...array.slice(index + 1)
                    ]
                }
                if (item.type === "Combobox5") {
                    array = [
                        ...array.slice(0, index),
                        {
                            ...array[index],
                            content: item.content
                        },
                        ...array.slice(index + 1)
                    ]
                }
            })
            SetDataPlanTypeConfiguration([...array]);
        
            
        }
    // eslint-disable-next-line
    }, [TenDuAn])

    const HandleOnChange = (e, index, Type) => {
        if (Type === "File") {
            props.UploadFile(e[0], index);
        } else if (Type === "Azure Email") {
            SetDataPlanTypeConfiguration([
                ...DataPlanTypeConfiguration.slice(0, index),
                {
                    ...DataPlanTypeConfiguration[index],
                    content: e,
                },
                ...DataPlanTypeConfiguration.slice(index + 1)
            ]);
        }
       
        
        else {
            if (Type === "Combobox1") {
                SetTenDuAn(e);
                SetDataPlanTypeConfiguration([
                    ...DataPlanTypeConfiguration.slice(0, index),
                    {
                        ...DataPlanTypeConfiguration[index],
                        content: e
                    },
                    ...DataPlanTypeConfiguration.slice(index + 1)
                ]);
            }
            else if (Type === "Combobox2") {
                SetDataPlanTypeConfiguration([
                    ...DataPlanTypeConfiguration.slice(0, index),
                    {
                        ...DataPlanTypeConfiguration[index],
                        content: e
                    },
                    ...DataPlanTypeConfiguration.slice(index + 1)
                ]);
            }
            else if (Type === "Combobox3") {
                SetDataPlanTypeConfiguration([
                    ...DataPlanTypeConfiguration.slice(0, index),
                    {
                        ...DataPlanTypeConfiguration[index],
                        content: e
                    },
                    ...DataPlanTypeConfiguration.slice(index + 1)
                ]);
            }
            else if (Type === "Combobox4") {
                SetDataPlanTypeConfiguration([
                    ...DataPlanTypeConfiguration.slice(0, index),
                    {
                        ...DataPlanTypeConfiguration[index],
                        content: e
                    },
                    ...DataPlanTypeConfiguration.slice(index + 1)
                ]);
            }
            else if (Type === "Combobox5") {
                SetDataPlanTypeConfiguration([
                    ...DataPlanTypeConfiguration.slice(0, index),
                    {
                        ...DataPlanTypeConfiguration[index],
                        content: e
                    },
                    ...DataPlanTypeConfiguration.slice(index + 1)
                ]);
            }
            else {
                SetDataPlanTypeConfiguration([
                    ...DataPlanTypeConfiguration.slice(0, index),
                    {
                        ...DataPlanTypeConfiguration[index],
                        content: HandleCovertEventToDateTime(e, Type),
                    },
                    ...DataPlanTypeConfiguration.slice(index + 1)
                ]);
            }
        }
        if(window.location.pathname.includes('Edit')){
            return;
        }else{
            localStorage.setItem(`DataPlanTypeDraft${id}`, JSON.stringify(DataPlanTypeConfiguration))
        }
       
    }

    const handleGetInputTextAzureEmail = useCallback((value) => {
        setCurrentKeyword(value)
    }, [])

    const handleUpdateStateDataPlanHandle = (newValue, index, type) => {
        //Only for Type Azure Email now
        if (currentEmailAzure.length > 0) {
            // eslint-disable-next-line
            currentEmailAzure.map((val) => {
                // eslint-disable-next-line
                if (val.id = index) {
                    val.data = [...newValue];
                } else {
                    val.data = newValue;
                }
            })
        }

        //call function set state for data plan can save into DB        
        const dataPlanHandleField = []
        // eslint-disable-next-line
        newValue.map(obj => {
            const value = obj.value
            dataPlanHandleField.push(value)
        })
        HandleOnChange(newValue.join("*"), index, type)
    }

    const HandleOnChangeTabPanel = (e, index, Type) => {
        if (Type === "RemoveFile") {
            SetDataPlanTypeConfigurationMain([
                ...DataPlanTypeConfigurationMain.slice(0, value),
                {
                    ...DataPlanTypeConfigurationMain[value],
                    planTypeConfiguration: [
                        ...DataPlanTypeConfigurationMain[value].planTypeConfiguration.slice(0, index),
                        {
                            ...DataPlanTypeConfigurationMain[value].planTypeConfiguration[index],
                            content: null
                        },
                        ...DataPlanTypeConfigurationMain[value].planTypeConfiguration.slice(index + 1),
                    ]
                },
                ...DataPlanTypeConfigurationMain.slice(value + 1)
            ])
        } else {
            SetDataPlanTypeConfigurationMain([
                ...DataPlanTypeConfigurationMain.slice(0, value),
                {
                    ...DataPlanTypeConfigurationMain[value],
                    planTypeConfiguration: [
                        ...DataPlanTypeConfigurationMain[value].planTypeConfiguration.slice(0, index),
                        {
                            ...DataPlanTypeConfigurationMain[value].planTypeConfiguration[index],
                            content: e
                        },
                        ...DataPlanTypeConfigurationMain[value].planTypeConfiguration.slice(index + 1),
                    ]
                },
                ...DataPlanTypeConfigurationMain.slice(value + 1)
            ])
        }
        if(window.location.pathname.includes('Edit')){
            return;
        }else{
            localStorage.setItem(`DataPlanTypeMainDraft${id}`, JSON.stringify(DataPlanTypeConfigurationMain))
        }
    }

    const handleCloseShowDraft = () => {
        setShowDraft(false)
        localStorage.removeItem(`DataPlanTypeMainDraft${id}`)
        localStorage.removeItem(`DataPlanTypeDraft${id}`)
        window.location.reload()
    };
    
    const handleAgreeShowDraft = () => {
        setShowDraft(false)

        // Xử lí bản nháp của PlanTypeConfiguration theo config mới
        let arrOld = JSON.parse(localStorage.getItem(`DataPlanTypeDraft${id}`)) ;
        let arrNew = props.DataNew.PlanTypeConfiguration;
        if(arrOld === null || arrOld === undefined){
            return;
        } else{
            const filteredArray = arrNew.filter(obj => obj.type !== "Link liên kết");
            arrOld.forEach(itemOld => {
                filteredArray.forEach(itemNew => {
                  if (itemOld.name === itemNew.name && (itemOld.type.includes("Combobox") || itemOld.type === itemNew.type)) {
                    itemNew.content = itemOld.content;
                    itemNew.data = itemOld.data;
                    itemNew.type = itemOld.type;
                  }

                });
              });

            let arraySort = filteredArray.map((item) =>{
                return {...item, index: item.planTypeConfigurationRefID !==0 ? item.planTypeConfigurationRefID : item.id}
            })
            const numAscending = arraySort.sort((a, b) => {
                return a.index - b.index;
            });
            SetDataPlanTypeConfiguration(numAscending)
            SetTenDuAn(numAscending[0].content)
            setCheckClone(true)
        }

        // Xử lí bản nháp của PlanTypeConfigurationMain theo config mới        
        let arrOldMain = JSON.parse(localStorage.getItem(`DataPlanTypeMainDraft${id}`)) ;
        let arrNewMain = props.DataNew.PlanTypeConfigurationMain;
       
        if(arrOldMain === null  || arrOldMain === undefined) {
            return;
        }else{ 
            arrOldMain.forEach(itemOld => {
                arrNewMain.forEach(itemNew => {
                  if (itemOld.stepName === itemNew.stepName) {
                    itemNew.planTypeConfiguration[0].content = itemOld.planTypeConfiguration[0].content;
                  }
                });
              });
            SetDataPlanTypeConfigurationMain(arrNewMain)
        }
    }

    if (!DataPlanTypeConfiguration || !DataPlanTypeConfigurationMain) {
        return <div style={{ position: "fixed", top: "50%", left: "50%", transform: "translate(-50%, -50%)" }} >
            <TwinSpin color="var(--itsm-bg-btn)" width="50px" height="50px" duration="0.5s" />
        </div>
    }

    return (
        <>
            <Backdrop
                sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                open={openBackdrop}
                // onClick={handleCloseBackdrop}
            >
                 <TwinSpin color="var(--itsm-bg-btn)" width="50px" height="50px" duration="0.5s" />
            </Backdrop>
            <div>
                <Dialog
                    open={ShowDraft}
                    // onClose={handleCloseShowDraft}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >
                    <DialogTitle
                        id="alert-dialog-title"
                        className="popupHandle"
                    >
                        Thông báo
                        {/* <IconButton
                        style={{ marginLeft: 250 }}
                        onClick={handleCloseShowDraft}
                    >
                        <MdClose />
                    </IconButton> */}
                    </DialogTitle>
                    <DialogContent>
                        <DialogContentText
                            id="alert-dialog-description"
                            style={{ textAlign: "center" }}
                        >
                            <p>Bạn có muốn sử dụng bản nháp?</p>
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button
                            className="PlanTemplate_0021 text-light"
                            // onClick={() =>
                            //     setShowDraft(false)
                            // }
                            onClick={handleAgreeShowDraft}
                            style={{ backgroundColor: "#6FB554" }}
                            autoFocus
                        >
                            Đồng ý
                        </Button>
                        <Button
                            className="PlanTemplate_0021 text-light"
                            style={{ backgroundColor: "#DA9630" }}
                            onClick={handleCloseShowDraft}
                        >
                            Xóa
                        </Button>
                    </DialogActions>
                </Dialog>
            </div>
            <div className={`fn ${sticky && "sticky"}`} ref={refHeader} >
                {/* <Button
                    onClick={handleSave}
                    className={classes.btnSave}
                    variant="contained"
                    startIcon={<MdSave />}
                >
                    Lưu
                </Button> */}
                <Button
                    onClick={handleSaveDefaultData}
                    style={{ width: "172px" }}
                    className={classes.btnSave}
                    variant="contained"
                    startIcon={<MdContentCopy />}
                >
                    Đặt làm mặc định
                </Button>
                <Button
                    onClick={handleCancel}
                    className={classes.btnCancel}
                    variant="contained"
                    startIcon={<MdArrowBackIosNew />}
                >
                    Quay lại
                </Button>
            </div>
            <div className="plan-handle-new">
                {!isLoading ?
                    <div className="plan-handle-new-body">
                        {DataPlanTypeConfiguration && <RenderLayout data={DataPlanTypeConfiguration} onChange={HandleOnChange} handleDownload={(handleDownload)} currentEmailAzure={currentEmailAzure} handleGetInputTextAzureEmail={handleGetInputTextAzureEmail} currentValue={currentValue} handleUpdateStateDataPlanHandle={handleUpdateStateDataPlanHandle} />}
                        <div className="plan-handle-new-tab">
                            <Tabs
                                orientation="vertical"
                                variant="scrollable"
                                value={value}
                                onChange={handleChange}
                                className={classes.tabs}
                            >
                                {DataPlanTypeConfigurationMain && DataPlanTypeConfigurationMain.map((item, index) => {
                                    return <Tab key={index} label={item.stepName} />
                                })}
                            </Tabs>
                            {DataPlanTypeConfigurationMain && <TabPanel value={value} data={DataPlanTypeConfigurationMain} onChange={HandleOnChangeTabPanel} />}
                        </div>
                    </div>
                    :
                    <>
                        <div style={{ position: "fixed", top: "50%", left: "50%", transform: "translate(-50%, -50%)" }} >
                            <TwinSpin color="var(--itsm-bg-btn)" width="50px" height="50px" duration="0.5s" />
                        </div></>
                }
            </div>
        </>
    );
}
